import React from 'react'

function Footer() {
  return (
    <div>
        <div className="flex items-center justify-center bg-black h-52">
          <div className="flex flex-col justify-center gap-10 text-[#9b9b9b] header-subtitle">
            <p className="text-sm">All Rights Reserved. © 2025</p>
            <p className="text-md">Made by Emirhan Gungor</p>
          </div>
        </div>
    </div>
  )
}

export default Footer